export const btnSizes = [
    'lg',
    'md',
    'sm',
    'xs',
    'large',
    'medium',
    'small',
    'extra-small'
];

export const btnStyles = [
    'default',
    'primary',
    'danger',
    'emphasis', // alias of "danger"
    'border',
    'flat', // alias of "border"
    'link'
];



// WEBPACK FOOTER //
// ./src/constants.js